module.exports = __webpack_public_path__ + "static/media/agilis-divida-logo.14583264.svg";